const locale = {
  TITLE_CONNECTION_ISSUE: 'Oops! Something happened',
  SUBTITLE_CONNECTION_ISSUE: "It looks like we're having some trouble connecting. Please try again later",
  HOME_BUTTON_CONNECTION_ISSUE: 'Go home',
};

export default locale;
